<template>
  <h2 class="gmf-header" v-if="title">{{title}}</h2>

  <div class="gmf-pinned-post-background" v-if="backgroundUrl" :style="`background-image: url(${backgroundUrl})`"></div>

  <CompactPost :post="pinnedPost" v-if="pinnedPost" />
</template>

<style>
.gmf-pinned-post {
  padding: var(--gmf-p-3);
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.gmf-pinned-post .gmf-header {
  padding: var(--gmf-p-3);
  margin-bottom: var(--gmf-p-4);
  z-index: 1;
}

.gmf-pinned-post-background {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  inset: 0;
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';

import { defineAsyncComponent } from 'vue';

const CompactPost = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'./CompactPost.vue');
});
export default {
  components: { CompactPost },

  props: {
    post: {
      type: Object,
      default: null,
      required: false,
    },
  },

  computed: {
    backgroundUrl() {
      return state.merchantConfig?.widgets?.pinnedPost?.background || null;
    },

    translationsEnabled() {
      return state.merchantConfig?.widgets?.translations.mode !== 'translateNothing';
    },

    title() {
      return this.pinnedPost && this.pinnedPost.content && this.pinnedPost.content.title 
        ? this.pinnedPost.content.title : null;
    },
  },

  data: () => ({
    pinnedPost: null,
  }),

  async mounted() {
    if (this.post) {
      this.pinnedPost = this.post;
      return;
    }

    const res = await callApi('GET', state.commentSearchEndpoint + `?take=1&pin=start_page&translate=${this.translationsEnabled}`);

    const data = await res.json();

    const comment = data?.comments.find(c => c.pins && c.pins.length > 0 && c.pins.includes('start_page'));

    if (comment) {
      this.pinnedPost = comment;
    }
  },
}
</script>